import React from "react";
import Card from "react-bootstrap/Card";
import { useAbout } from "../../hooks/usePortfolioData";

function AboutCard() {
  const { about, loading } = useAbout();

  // Fallback content if data not loaded
  const defaultBio = "I am a Junior Internet of Things (IoT) Developer with a strong foundation in embedded systems and connected technologies.";
  const defaultEducation = "I hold a Bachelor's degree in Computer Systems Engineering from the University of Sousse, Tunisia, where I developed solid problem-solving skills and technical expertise to address complex technology challenges.";
  
  const bio = about?.bio || defaultBio;
  const education = about?.education || defaultEducation;

  if (loading) {
    return (
      <Card className="quote-card-view">
        <Card.Body>
          <p className="home-about-body">Loading...</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <p className="home-about-body" dangerouslySetInnerHTML={{ __html: bio }} />
        <br />
        <br />
        <p className="home-about-body" dangerouslySetInnerHTML={{ __html: education }} />
        <br />
        <br />
        <p className="home-about-body">
          I am passionate about leveraging technology to solve real-world problems, always seeking new learning opportunities, and working on projects that drive meaningful impact and innovation.
        </p>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
